import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    settings: {
        modalOpen: false,
    },
}

export const metaSlice = createSlice({
    name: 'meta',
    initialState,
    reducers: {
        toggleSettingsModal: state => {
            state.settings.modalOpen = !state.settings.modalOpen
        },
    },
})

export const selectSettingsModalOpen = state => state.meta.settings.modalOpen

export const metaReducer = metaSlice.reducer
export const metaActions = metaSlice.actions
